module.exports = __webpack_public_path__ + "img/logo.ORIGINAL.f1840b74.png";